/* js/components/mediaPlayers/Rts.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	src_url_equal
} from "svelte/internal";

function create_fragment(ctx) {
	let iframe;
	let iframe_src_value;

	return {
		c() {
			iframe = element("iframe");
			attr(iframe, "class", "play-rts svelte-etyj1k");
			if (!src_url_equal(iframe.src, iframe_src_value = /*src*/ ctx[0])) attr(iframe, "src", iframe_src_value);
			iframe.allowFullscreen = true;
			attr(iframe, "allow", "geolocation *; autoplay; encrypted-media");
		},
		m(target, anchor) {
			insert(target, iframe, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*src*/ 1 && !src_url_equal(iframe.src, iframe_src_value = /*src*/ ctx[0])) {
				attr(iframe, "src", iframe_src_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(iframe);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { src } = $$props;

	$$self.$$set = $$props => {
		if ('src' in $$props) $$invalidate(0, src = $$props.src);
	};

	return [src];
}

class Rts extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { src: 0 });
	}
}

export default Rts;